"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliverableReportPropertySchema = exports.DeliverablePropertySchema = void 0;
// DEPRECATED namespace exports converted to module
const z = __importStar(require("zod"));
const Deliverable = __importStar(require("../../Deliverable"));
const Utils = __importStar(require("../../Utils"));
const Config = __importStar(require("../Config"));
const DomainEntity_1 = require("./DomainEntity");
// Zod schemas for DEPRECATED.DeliverableProperty
const DeliverableBasePropertySchema = DomainEntity_1.BasePropertySchema.extend({
    type: z.literal(DomainEntity_1.PropertyType.DeliverableProperty),
    value: z.enum(Deliverable.v3DEPRECATED.DeliverableValueTypes),
    responsibleParties: z.array(z.object({ _id_: z.string() })),
    dueDates: z.array(Utils.ZodFullDateStrLightWeightStruct),
    _config_: Config.DeliverablePropertyDEPRECATED.ConfigSchema,
});
const DeliverableNoSubmissionPropertySchema = DeliverableBasePropertySchema.extend({
    value: z.literal('noSubmission'),
});
const DeliverableNonFilePropertySchema = DeliverableBasePropertySchema.extend({
    value: z.enum(['string', 'number', 'boolean']),
});
const DeliverableFilePropertySchema = DeliverableBasePropertySchema.extend({
    value: z.literal('file'),
    fileTypes: z.array(z.string()),
});
exports.DeliverablePropertySchema = z.discriminatedUnion('value', [
    DeliverableNoSubmissionPropertySchema,
    DeliverableNonFilePropertySchema,
    DeliverableFilePropertySchema,
]);
// @jendevelops deliverables-deprecated
// Re-export from DomainEntity to maintain backward compatibility
// (The schema is defined in DomainEntity to avoid circular dependency)
exports.DeliverableReportPropertySchema = DomainEntity_1.DeliverableReportPropertySchema;
//# sourceMappingURL=DEPRECATED.js.map